import { render, staticRenderFns } from "./SSelectEducationalInstitution.vue?vue&type=template&id=1f0daf8c"
import script from "./SSelectEducationalInstitution.vue?vue&type=script&lang=js"
export * from "./SSelectEducationalInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports